import SetAuthorMobileForm from '@/views/common/account/base-info/set-author-mobile-form.vue';
import { useComponentModal } from '@/share/components';

export const useSetAuthorMobileModal = () => {
    const { openEditor } = useComponentModal();

    const showSetAuthorMobileModal = async (title) => {
        return openEditor(title, SetAuthorMobileForm, {}, {
            width: '600px',
            showMaximize: false,
            showMinimize: false,
        });
    };

    return {
        showSetAuthorMobileModal,
    };
};
